/*
 * Copyright (c) 2023 D2ArmorPicker by Mijago.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// Dicts: [artifice, minor, major, total]

export const precalculatedZeroWasteModCombinations: {
  [key: number]: [number, number, number, number][];
} = {
  1: [
    [2, 1, 0, 11],
    [2, 3, 0, 21],
    [2, 1, 1, 21],
    [2, 1, 2, 31],
  ],
  2: [
    [4, 0, 0, 12],
    [4, 2, 0, 22],
    [4, 0, 1, 22],
    [4, 4, 0, 32],
    [4, 0, 2, 32],
  ],
  3: [
    [1, 0, 0, 3],
    [1, 2, 0, 13],
    [1, 0, 1, 13],
    [1, 4, 0, 23],
    [1, 2, 1, 23],
    [1, 0, 2, 23],
    [1, 2, 2, 33],
  ],
  4: [
    [3, 1, 0, 14],
    [3, 3, 0, 24],
    [3, 1, 1, 24],
    [3, 1, 2, 34],
  ],
  5: [
    [0, 1, 0, 5],
    [5, 0, 0, 15],
    [0, 3, 0, 15],
    [0, 1, 1, 15],
    [5, 2, 0, 25],
    [5, 0, 1, 25],
    [0, 3, 1, 25],
    [0, 1, 2, 25],
    [5, 4, 0, 35],
    [5, 0, 2, 35],
    [0, 3, 2, 35],
  ],
  6: [
    [2, 0, 0, 6],
    [2, 2, 0, 16],
    [2, 0, 1, 16],
    [2, 4, 0, 26],
    [2, 2, 1, 26],
    [2, 0, 2, 26],
    [2, 2, 2, 36],
    [2, 0, 3, 36],
    [2, 2, 3, 46],
  ],
  7: [
    [4, 1, 0, 17],
    [4, 3, 0, 27],
    [4, 1, 1, 27],
    [4, 5, 0, 37],
    [4, 1, 2, 37],
    [4, 1, 3, 47],
  ],
  8: [
    [1, 1, 0, 8],
    [1, 3, 0, 18],
    [1, 1, 1, 18],
    [1, 5, 0, 28],
    [1, 3, 1, 28],
    [1, 1, 2, 28],
    [1, 3, 2, 38],
    [1, 1, 3, 38],
  ],
  9: [
    [3, 0, 0, 9],
    [3, 2, 0, 19],
    [3, 0, 1, 19],
    [3, 4, 0, 29],
    [3, 2, 1, 29],
    [3, 0, 2, 29],
    [3, 2, 2, 39],
    [3, 0, 3, 39],
    [3, 2, 3, 49],
  ],
  10: [
    [0, 2, 0, 10],
    [0, 0, 1, 10],
    [5, 1, 0, 20],
    [0, 4, 0, 20],
    [0, 2, 1, 20],
    [0, 0, 2, 20],
    [5, 3, 0, 30],
    [5, 1, 1, 30],
    [0, 4, 1, 30],
    [0, 2, 2, 30],
    [0, 0, 3, 30],
    [5, 5, 0, 40],
    [5, 1, 2, 40],
    [0, 2, 3, 40],
    [5, 1, 3, 50],
  ],
  11: [
    [2, 1, 0, 11],
    [2, 3, 0, 21],
    [2, 1, 1, 21],
    [2, 5, 0, 31],
    [2, 3, 1, 31],
    [2, 1, 2, 31],
    [2, 3, 2, 41],
    [2, 1, 3, 41],
  ],
  12: [
    [4, 0, 0, 12],
    [4, 2, 0, 22],
    [4, 0, 1, 22],
    [4, 4, 0, 32],
    [4, 2, 1, 32],
    [4, 0, 2, 32],
    [4, 2, 2, 42],
    [4, 0, 3, 42],
    [4, 2, 3, 52],
  ],
  13: [
    [1, 2, 0, 13],
    [1, 0, 1, 13],
    [1, 4, 0, 23],
    [1, 2, 1, 23],
    [1, 0, 2, 23],
    [1, 4, 1, 33],
    [1, 2, 2, 33],
    [1, 0, 3, 33],
    [1, 2, 3, 43],
  ],
  14: [
    [3, 1, 0, 14],
    [3, 3, 0, 24],
    [3, 1, 1, 24],
    [3, 5, 0, 34],
    [3, 3, 1, 34],
    [3, 1, 2, 34],
    [3, 3, 2, 44],
    [3, 1, 3, 44],
  ],
  15: [
    [5, 0, 0, 15],
    [0, 3, 0, 15],
    [0, 1, 1, 15],
    [5, 2, 0, 25],
    [0, 5, 0, 25],
    [5, 0, 1, 25],
    [0, 3, 1, 25],
    [0, 1, 2, 25],
    [5, 4, 0, 35],
    [5, 2, 1, 35],
    [5, 0, 2, 35],
    [0, 3, 2, 35],
    [0, 1, 3, 35],
    [5, 2, 2, 45],
    [5, 0, 3, 45],
    [5, 2, 3, 55],
  ],
  16: [
    [2, 2, 0, 16],
    [2, 0, 1, 16],
    [2, 4, 0, 26],
    [2, 2, 1, 26],
    [2, 0, 2, 26],
    [2, 4, 1, 36],
    [2, 2, 2, 36],
    [2, 0, 3, 36],
    [2, 2, 3, 46],
    [2, 0, 4, 46],
  ],
  17: [
    [4, 1, 0, 17],
    [4, 3, 0, 27],
    [4, 1, 1, 27],
    [4, 5, 0, 37],
    [4, 3, 1, 37],
    [4, 1, 2, 37],
    [4, 3, 2, 47],
    [4, 1, 3, 47],
    [4, 1, 4, 57],
  ],
  18: [
    [1, 3, 0, 18],
    [1, 1, 1, 18],
    [1, 5, 0, 28],
    [1, 3, 1, 28],
    [1, 1, 2, 28],
    [1, 3, 2, 38],
    [1, 1, 3, 38],
    [1, 1, 4, 48],
  ],
  19: [
    [3, 2, 0, 19],
    [3, 0, 1, 19],
    [3, 4, 0, 29],
    [3, 2, 1, 29],
    [3, 0, 2, 29],
    [3, 4, 1, 39],
    [3, 2, 2, 39],
    [3, 0, 3, 39],
    [3, 2, 3, 49],
    [3, 0, 4, 49],
  ],
  20: [
    [5, 1, 0, 20],
    [0, 4, 0, 20],
    [0, 2, 1, 20],
    [0, 0, 2, 20],
    [5, 3, 0, 30],
    [5, 1, 1, 30],
    [0, 4, 1, 30],
    [0, 2, 2, 30],
    [0, 0, 3, 30],
    [5, 5, 0, 40],
    [5, 3, 1, 40],
    [5, 1, 2, 40],
    [0, 2, 3, 40],
    [0, 0, 4, 40],
    [5, 3, 2, 50],
    [5, 1, 3, 50],
    [5, 1, 4, 60],
  ],
  21: [
    [2, 3, 0, 21],
    [2, 1, 1, 21],
    [2, 5, 0, 31],
    [2, 3, 1, 31],
    [2, 1, 2, 31],
    [2, 3, 2, 41],
    [2, 1, 3, 41],
    [2, 1, 4, 51],
  ],
  22: [
    [4, 2, 0, 22],
    [4, 0, 1, 22],
    [4, 4, 0, 32],
    [4, 2, 1, 32],
    [4, 0, 2, 32],
    [4, 4, 1, 42],
    [4, 2, 2, 42],
    [4, 0, 3, 42],
    [4, 2, 3, 52],
    [4, 0, 4, 52],
  ],
  23: [
    [1, 4, 0, 23],
    [1, 2, 1, 23],
    [1, 0, 2, 23],
    [1, 4, 1, 33],
    [1, 2, 2, 33],
    [1, 0, 3, 33],
    [1, 2, 3, 43],
    [1, 0, 4, 43],
  ],
  24: [
    [3, 3, 0, 24],
    [3, 1, 1, 24],
    [3, 5, 0, 34],
    [3, 3, 1, 34],
    [3, 1, 2, 34],
    [3, 3, 2, 44],
    [3, 1, 3, 44],
    [3, 1, 4, 54],
  ],
  25: [
    [5, 2, 0, 25],
    [0, 5, 0, 25],
    [5, 0, 1, 25],
    [0, 3, 1, 25],
    [0, 1, 2, 25],
    [5, 4, 0, 35],
    [5, 2, 1, 35],
    [5, 0, 2, 35],
    [0, 3, 2, 35],
    [0, 1, 3, 35],
    [5, 4, 1, 45],
    [5, 2, 2, 45],
    [5, 0, 3, 45],
    [0, 1, 4, 45],
    [5, 2, 3, 55],
    [5, 0, 4, 55],
  ],
  26: [
    [2, 4, 0, 26],
    [2, 2, 1, 26],
    [2, 0, 2, 26],
    [2, 4, 1, 36],
    [2, 2, 2, 36],
    [2, 0, 3, 36],
    [2, 2, 3, 46],
    [2, 0, 4, 46],
    [2, 0, 5, 56],
  ],
  27: [
    [4, 3, 0, 27],
    [4, 1, 1, 27],
    [4, 5, 0, 37],
    [4, 3, 1, 37],
    [4, 1, 2, 37],
    [4, 3, 2, 47],
    [4, 1, 3, 47],
    [4, 1, 4, 57],
  ],
  28: [
    [1, 5, 0, 28],
    [1, 3, 1, 28],
    [1, 1, 2, 28],
    [1, 3, 2, 38],
    [1, 1, 3, 38],
    [1, 1, 4, 48],
  ],
  29: [
    [3, 4, 0, 29],
    [3, 2, 1, 29],
    [3, 0, 2, 29],
    [3, 4, 1, 39],
    [3, 2, 2, 39],
    [3, 0, 3, 39],
    [3, 2, 3, 49],
    [3, 0, 4, 49],
    [3, 0, 5, 59],
  ],
  30: [
    [5, 3, 0, 30],
    [5, 1, 1, 30],
    [0, 4, 1, 30],
    [0, 2, 2, 30],
    [0, 0, 3, 30],
    [5, 5, 0, 40],
    [5, 3, 1, 40],
    [5, 1, 2, 40],
    [0, 2, 3, 40],
    [0, 0, 4, 40],
    [5, 3, 2, 50],
    [5, 1, 3, 50],
    [0, 0, 5, 50],
    [5, 1, 4, 60],
  ],
  31: [
    [2, 5, 0, 31],
    [2, 3, 1, 31],
    [2, 1, 2, 31],
    [2, 3, 2, 41],
    [2, 1, 3, 41],
    [2, 1, 4, 51],
  ],
  32: [
    [4, 4, 0, 32],
    [4, 2, 1, 32],
    [4, 0, 2, 32],
    [4, 4, 1, 42],
    [4, 2, 2, 42],
    [4, 0, 3, 42],
    [4, 2, 3, 52],
    [4, 0, 4, 52],
    [4, 0, 5, 62],
  ],
  33: [
    [1, 4, 1, 33],
    [1, 2, 2, 33],
    [1, 0, 3, 33],
    [1, 2, 3, 43],
    [1, 0, 4, 43],
    [1, 0, 5, 53],
  ],
  34: [
    [3, 5, 0, 34],
    [3, 3, 1, 34],
    [3, 1, 2, 34],
    [3, 3, 2, 44],
    [3, 1, 3, 44],
    [3, 1, 4, 54],
  ],
  35: [
    [5, 4, 0, 35],
    [5, 2, 1, 35],
    [5, 0, 2, 35],
    [0, 3, 2, 35],
    [0, 1, 3, 35],
    [5, 4, 1, 45],
    [5, 2, 2, 45],
    [5, 0, 3, 45],
    [0, 1, 4, 45],
    [5, 2, 3, 55],
    [5, 0, 4, 55],
    [5, 0, 5, 65],
  ],
  36: [
    [2, 4, 1, 36],
    [2, 2, 2, 36],
    [2, 0, 3, 36],
    [2, 2, 3, 46],
    [2, 0, 4, 46],
    [2, 0, 5, 56],
  ],
  37: [
    [4, 5, 0, 37],
    [4, 3, 1, 37],
    [4, 1, 2, 37],
    [4, 3, 2, 47],
    [4, 1, 3, 47],
    [4, 1, 4, 57],
  ],
  38: [
    [1, 3, 2, 38],
    [1, 1, 3, 38],
    [1, 1, 4, 48],
  ],
  39: [
    [3, 4, 1, 39],
    [3, 2, 2, 39],
    [3, 0, 3, 39],
    [3, 2, 3, 49],
    [3, 0, 4, 49],
    [3, 0, 5, 59],
  ],
  40: [
    [5, 5, 0, 40],
    [5, 3, 1, 40],
    [5, 1, 2, 40],
    [0, 2, 3, 40],
    [0, 0, 4, 40],
    [5, 3, 2, 50],
    [5, 1, 3, 50],
    [0, 0, 5, 50],
    [5, 1, 4, 60],
  ],
  41: [
    [2, 3, 2, 41],
    [2, 1, 3, 41],
    [2, 1, 4, 51],
  ],
  42: [
    [4, 4, 1, 42],
    [4, 2, 2, 42],
    [4, 0, 3, 42],
    [4, 2, 3, 52],
    [4, 0, 4, 52],
    [4, 0, 5, 62],
  ],
  43: [
    [1, 2, 3, 43],
    [1, 0, 4, 43],
    [1, 0, 5, 53],
  ],
  44: [
    [3, 3, 2, 44],
    [3, 1, 3, 44],
    [3, 1, 4, 54],
  ],
  45: [
    [5, 4, 1, 45],
    [5, 2, 2, 45],
    [5, 0, 3, 45],
    [0, 1, 4, 45],
    [5, 2, 3, 55],
    [5, 0, 4, 55],
    [5, 0, 5, 65],
  ],
  46: [
    [2, 2, 3, 46],
    [2, 0, 4, 46],
    [2, 0, 5, 56],
  ],
  47: [
    [4, 3, 2, 47],
    [4, 1, 3, 47],
    [4, 1, 4, 57],
  ],
  48: [[1, 1, 4, 48]],
  49: [
    [3, 2, 3, 49],
    [3, 0, 4, 49],
    [3, 0, 5, 59],
  ],
  50: [
    [5, 3, 2, 50],
    [5, 1, 3, 50],
    [0, 0, 5, 50],
    [5, 1, 4, 60],
  ],
  51: [[2, 1, 4, 51]],
  52: [
    [4, 2, 3, 52],
    [4, 0, 4, 52],
    [4, 0, 5, 62],
  ],
  53: [[1, 0, 5, 53]],
  54: [[3, 1, 4, 54]],
  55: [
    [5, 2, 3, 55],
    [5, 0, 4, 55],
    [5, 0, 5, 65],
  ],
  56: [[2, 0, 5, 56]],
  57: [[4, 1, 4, 57]],
  58: [],
  59: [[3, 0, 5, 59]],
  60: [[5, 1, 4, 60]],
  61: [],
  62: [[4, 0, 5, 62]],
  63: [],
  64: [],
  65: [[5, 0, 5, 65]],
};
